<template>
  <v-dialog :value="value" max-width="800px" persistent scrollable @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon color="white" class="mr-2">mdi-file-upload</v-icon>
        {{ title }}
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close" :disabled="working">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-6">
        <p class="text-body-2">
          Descarga la plantilla, rellénala y súbela. Las filas correctas se importan y las que tengan
          errores se muestran abajo con su número de fila.
        </p>
        <v-btn outlined color="primary" small :loading="downloading" @click="downloadTemplate">
          <v-icon left small>mdi-download</v-icon>
          Descargar plantilla
        </v-btn>

        <v-file-input
          v-model="file"
          class="mt-6"
          label="Fichero (.xlsx, .xls o .csv)"
          accept=".xlsx,.xls,.csv"
          outlined
          dense
          show-size
          prepend-icon="mdi-paperclip"
          :disabled="working"
          @change="summary = null"
        ></v-file-input>

        <template v-if="summary">
          <v-alert :type="summary.error_count ? 'warning' : 'success'" text dense>
            <template v-if="summary.dry_run">
              Validación: {{ summary.valid_rows }} de {{ summary.total_rows }} fila(s) correctas.
            </template>
            <template v-else>
              Importadas {{ summary.created_count }} de {{ summary.total_rows }} fila(s).
            </template>
            <span v-if="summary.error_count"> {{ summary.error_count }} fila(s) con errores.</span>
          </v-alert>

          <v-simple-table v-if="summary.errors.length" dense>
            <thead>
              <tr>
                <th style="width: 80px;">Fila</th>
                <th>Registro</th>
                <th>Errores</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="err in summary.errors" :key="err.row">
                <td>{{ err.row }}</td>
                <td>{{ err.email || err.name || '—' }}</td>
                <td>
                  <div v-for="(msg, i) in err.errors" :key="i" class="error--text text-caption">{{ msg }}</div>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </template>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="close" :disabled="working">Cerrar</v-btn>
        <v-btn outlined color="primary" :disabled="!file" :loading="working && dryRun" @click="run(true)">
          <v-icon left>mdi-check-all</v-icon>
          Validar
        </v-btn>
        <v-btn color="primary" :disabled="!file" :loading="working && !dryRun" @click="run(false)">
          <v-icon left>mdi-upload</v-icon>
          Importar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiData, apiError, downloadBlob } from '@/grupo'

export default {
  name: 'ImportDialog',

  props: {
    value: { type: Boolean, default: false },
    title: { type: String, required: true },
    templateName: { type: String, required: true },
    // () => Promise con el blob de la plantilla
    templateFn: { type: Function, required: true },
    // (file, dryRun) => Promise con el resumen
    importFn: { type: Function, required: true }
  },

  data: () => ({
    file: null,
    summary: null,
    working: false,
    dryRun: false,
    downloading: false
  }),

  methods: {
    async downloadTemplate () {
      this.downloading = true
      try {
        const response = await this.templateFn()
        downloadBlob(response.data, this.templateName)
      } catch (error) {
        this.$toast.error('No se pudo descargar la plantilla')
      } finally {
        this.downloading = false
      }
    },

    async run (dryRun) {
      this.dryRun = dryRun
      this.working = true
      try {
        const response = await this.importFn(this.file, dryRun)
        this.summary = apiData(response)
        if (!dryRun && this.summary.created_count > 0) {
          this.$toast.success(`Importadas ${this.summary.created_count} fila(s)`)
          this.$emit('imported', this.summary)
        }
      } catch (error) {
        this.$toast.error(apiError(error, 'No se pudo procesar el fichero'))
      } finally {
        this.working = false
      }
    },

    close () {
      this.file = null
      this.summary = null
      this.$emit('input', false)
    }
  }
}
</script>
